export const CampaignType = {
  CASHBACK: 2,
  FREE_DELIVERY: 3,
  FREE_SERVICE_FEES: 4,
  INSTANT_DISCOUNT: 5
};

export const CampaignTypeLabels = {
  [CampaignType.CASHBACK]: 'Cashback',
  [CampaignType.FREE_DELIVERY]: 'Free Delivery',
  [CampaignType.FREE_SERVICE_FEES]: 'Free Service Fees',
  [CampaignType.INSTANT_DISCOUNT]: 'Instant Discount'
};

export const CampaignStatus = {
  DRAFT: 0,
  ACTIVE: 1,
  PAUSED: 2,
  STOPPED: 3
};

export const CampaignStatusLabels = {
  [CampaignStatus.DRAFT]: 'Draft',
  [CampaignStatus.ACTIVE]: 'Active',
  [CampaignStatus.PAUSED]: 'Paused',
  [CampaignStatus.STOPPED]: 'Stopped'
};

export const ValueType = {
  AMOUNT: 1,
  PERCENTAGE: 2
};

export const PaymentGate = {
  ONLINE_ONLY: 'ONLINE_ONLY',
  CASH_ONLY: 'CASH_ONLY',
  ANY: 'ANY'
};

export const FundingSource = {
  PLATFORM: 1,
  PROVIDER_FUNDED: 2
};

export const SettlementStrategy = {
  VPAY_WALLET: 1,
  LOYALTY_POINTS: 2
};

export const SettlementTrigger = {
  EVENT_DELIVERED: 1,
  EVENT_CHECKIN: 2,
  EVENT_COMPLETED: 3,
  TIME_BASED: 4,
  EVENT_CONFIRMED: 5
};

export const ALLOWED_STATUS_TRANSITIONS = {
  [CampaignStatus.DRAFT]: [CampaignStatus.ACTIVE],
  [CampaignStatus.ACTIVE]: [CampaignStatus.PAUSED, CampaignStatus.STOPPED],
  [CampaignStatus.PAUSED]: [CampaignStatus.ACTIVE, CampaignStatus.STOPPED],
  [CampaignStatus.STOPPED]: []
};

export const STATUS_ACTION_LABELS = {
  [CampaignStatus.ACTIVE]: 'Activate',
  [CampaignStatus.PAUSED]: 'Pause',
  [CampaignStatus.STOPPED]: 'Stop'
};

export const DEFAULT_CASHBACK_CONFIG = {
  settlementTrigger: null,
  requireFulfillment: true,
  reversalWindowHours: 72,
  cashSettlementDelayHours: 2,
  requiresAcknowledgement: false,
  settlementStrategy: SettlementStrategy.VPAY_WALLET
};

export const REWARD_PRODUCT_OPTIONS = [
  { ProductKey: 'Pro324', Name: 'Physical' },
  { ProductKey: 'InClinic', Name: 'In-Clinic Services' },
  { ProductKey: 'Labs', Name: 'Labs Services' },
  { ProductKey: 'Scans', Name: 'Scans Services' },
  { ProductKey: 'Surgical', Name: 'Surgical Services' },
  { ProductKey: 'Pro633', Name: 'Pharmacy' }
];

export const COUNTRY_KEY_OPTIONS = [
  { key: 'EG', label: 'Egypt (EG)' },
  { key: 'SA', label: 'Saudi Arabia (SA)' },
  { key: 'JO', label: 'Jordan (JO)' },
  { key: 'LB', label: 'Lebanon (LB)' },
  { key: 'NG', label: 'Nigeria (NG)' },
  { key: 'KE', label: 'Kenya (KE)' }
];

export const getStatusFromString = statusStr => {
  const map = {
    Draft: CampaignStatus.DRAFT,
    Active: CampaignStatus.ACTIVE,
    Paused: CampaignStatus.PAUSED,
    Stopped: CampaignStatus.STOPPED
  };
  return map[statusStr] !== undefined ? map[statusStr] : null;
};
